<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("DCR and Performance Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
                ? 'shift-up'
                : ''
                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
              <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
                :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
                @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                        ✖
                      </button> -->
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                        ✖
                      </button> -->
                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="GetDcrAndPerformanceReport('N')">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="dcrAndPerformanceData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center">
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a target="_blank" @click="GetDcrAndPerformanceReport((isExcel = 'Y'), 'N')" title="Download as Excel" download>
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
        <a target="_blank" title="Download as PDF" @click="GetDcrAndPerformanceReport((isExcel = 'N'), 'Y')">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table class="swc-report-table swc_table_header" border="1" v-if="dcrAndPerformanceData.length > 0">
            <thead class="bg-lightgrey">
              <tr>
                <th colspan="8">Distributors Report Admits / Gross Amount / VAT/ Net Amount</th>
                <th colspan="3">Performance Report Net Amount And Admits</th>

              </tr>
              <tr>
                <th>Date</th>
                <th>Movie</th>
                <th>Distributor</th>
                <th>Admits</th>
                <th>Gross Amount</th>
                <th>Vat</th>
                <th>Net Amount</th>
                <th>Week</th>
                <th>Admit</th>
                <th>Net Amount</th>
                <th>Difference</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in dcrAndPerformanceData" :key="index">
                <td class="text-left">
                  {{ currFormat(data.t_show_date) }}
                </td>
                <td class="text-left">
                  {{ currFormat(data.movie_name) }}
                </td>
                <td class="text-left">
                  {{ currFormat(data.dist_company_name) }}
                </td>
                <td class="text-right">
                  {{ data.admits }}
                </td>
                <td class="text-right">
                  {{ currFormat(data.dist_gross_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(data.dist_vat_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(data.dist_net_amount) }}
                </td>
                <td class="text-right">
                  {{ data.week }}
                </td>
                <td class="text-right">
                  {{ data.admits }}
                </td>
                <td class="text-right">
                  {{ currFormat(data.performance_net_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(data.dist_net_amount - data.performance_net_amount) }}
                </td>
              </tr>
            </tbody>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Grand Total</th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { admits }) => {
                        return acc + admits;
                      }, 0)

                  }}
                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { dist_gross_amount }) => {
                        return acc + dist_gross_amount;
                      }, 0)
                      .toFixed(this.MIN_FRACTION_DIGITS)
                  }}
                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { dist_vat_amount }) => {
                        return acc + dist_vat_amount;
                      }, 0)
                      .toFixed(this.MIN_FRACTION_DIGITS)
                  }}
                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { dist_net_amount }) => {
                        return acc + dist_net_amount;
                      }, 0)
                      .toFixed(this.MIN_FRACTION_DIGITS)
                  }}
                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { week }) => {
                        return acc + week;
                      }, 0)
                  }}

                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { admits }) => {
                        return acc + admits;
                      }, 0)

                  }}
                </th>
                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { performance_net_amount }) => {
                        return acc + performance_net_amount;
                      }, 0)
                      .toFixed(this.MIN_FRACTION_DIGITS)
                  }}
                </th>

                <th class="text-right">
                  {{
                    dcrAndPerformanceData
                      .reduce((acc, { dist_net_amount, performance_net_amount }) => {
                        return acc + dist_net_amount - performance_net_amount;
                      }, 0)
                      .toFixed(this.MIN_FRACTION_DIGITS)
                  }}
                </th>
              </tr>
            </thead>

          </table>
        </div>
      </div>

      <!--  -->
      <table class="swc-report-table swc_table_header table-scroll" border="1"
        v-if="dcrAndPerformanceData.length === 0">
        <thead class="bg-lightgrey">
          <tr>
            <th colspan="8">Distributors Report Admits / Gross Amount / VAT/ Net Amount</th>
            <th colspan="3">Performance Report Net Amount And Admits</th>

          </tr>
          <tr>
            <th>Date</th>
            <th>Movie</th>
            <th>Distributor</th>
            <th>Admits</th>
            <th>Gross Amount</th>
            <th>Vat</th>
            <th>Net Amount</th>
            <th>Week</th>
            <th>Admit</th>
            <th>Net Amount</th>
            <th>Difference</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="11">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,

      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      dcrAndPerformanceData: [],

    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() { },
  methods: {
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetDcrAndPerformanceReport(isExcel, isPdf = "N") {
      this.dcrAndPerformanceData = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf: isPdf
      };
      ReportsService.GetDcrAndPerformanceReport(payload)
        .then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            this.dcrAndPerformanceData = [...data.Records];
            //console.log("dcrAndPerformanceData", this.dcrAndPerformanceData)
            this.grandTotal = data.grandTotal;
            //console.log(this.grandTotal)
            if ((isExcel = "Y" && data.excelPath)) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
/* .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }
  
  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  .swc-report-table th {
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  } */
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dcrAndPerformanceReport.vue